import React, { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import s from './shopifyItem.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { getShipifyProductLink, Product } from '@services/toys/shopify';
import { useTranslation } from '@hooks/useTranslation';
import cn from 'classnames';
interface Props extends Product {}
export const ShopifyItem: FC<Props> = ({
  id: productId,
  handle,
  title,
  images
}) => {
  const {
    translate: tr
  } = useTranslation();
  const id = `product-${productId}-pagination`;
  return <div className={s.shopifyItem} data-sentry-component="ShopifyItem" data-sentry-source-file="ShopifyItem.tsx">
            <div className={s.shopifyItem__top}>
                <div className={s.shopifyItem__slider}>
                    <Swiper slidesPerView={1} modules={[Pagination]} loop={true} speed={1000} pagination={{
          clickable: true,
          el: `#${id}`,
          type: 'bullets',
          dynamicBullets: true,
          dynamicMainBullets: images.length > 5 ? 5 : images.length
        }} preventClicks data-sentry-element="Swiper" data-sentry-source-file="ShopifyItem.tsx">
                        {images.map(({
            src,
            alt,
            id
          }) => <SwiperSlide key={id}>
                                <img src={src} alt={alt ?? title} />
                            </SwiperSlide>)}
                    </Swiper>
                </div>
                <div className={s.shopifyItem__row}>
                    {images.length > 0 && <div className={s.shopifyItem__pagination} id={id}></div>}
                </div>
            </div>
            <div className={s.shopifyItem__main}>
                <div className={cn(s.shopifyItem__name, '_ellipsis')}>
                    {title}
                </div>
                <div className={s.shopifyItem__status}>

                </div>
            </div>
            <Button onClick={() => {
      window.open(getShipifyProductLink(handle), '_blank', 'noreferrer');
    }} size={'medium'} id={'shopify_button'} color={'Black'} data-sentry-element="Button" data-sentry-source-file="ShopifyItem.tsx">

                {tr({
        id: 'btn.buy'
      })}
            </Button>
        </div>;
};